import gql from 'graphql-tag';

export const suggestedIntegrationItemDokkioTagFragment = gql`
  fragment suggestedIntegrationItemDokkioTagFragment on SuggestedIntegrationItemDokkioTag {
    dokkioClass
    integrationID
    remoteID
    confidence
    dokkioTagID
  }
`;
export default suggestedIntegrationItemDokkioTagFragment;
